import React from 'react'

const NutritionistPage = () => {
  return (
    <div>NutritionistPage</div>
  )
}

export default NutritionistPage